import { InjectedConnector } from '@web3-react/injected-connector';

export default new InjectedConnector({
  supportedChainIds: [parseInt(process.env.NEXT_PUBLIC_CHAIN_ID) || 1],
});
